import { LinkedOrganization, User } from 'models/user';
import { Organization } from 'models/organization';

/**
 * The organization, role and active flag a user row shows. Role, active flag and
 * organization are per-organization data in `linkedOrganizations`, but super admins are
 * not scoped to one organization, so they see the root fields (the organization the
 * user last signed in to).
 */
export const resolveUserOrganization = (user: User): LinkedOrganization => ({
    organization: user.organization as Organization,
    role: user.role,
    active: user.active || false,
    type: user.type,
});
